var FormController = function(formSelector, elems, senders, endpoint) {

  if(document.querySelector(formSelector)){
    let _ = this;
    _.formSelector = formSelector;
    _.formNode = document.querySelector(formSelector);
    _.senders = NodeList.prototype.isPrototypeOf(senders) ? senders : [senders];
    _.elems = elems;

    _.successPopupId = "contactConfirmed";

    _.endPoint = endpoint;

    const defaultMandatoryMarker = '<span class="mandatoryMarker">*</span>';
    _.popUpBaseOption = {
      title: "",
      typeAnimated: false,
      type: "blue",
      closeIcon: true,
      columnClass: " col-xl-3 col-lg-4 col-md-5 col-sm-6 col-11",
      content: "",
      draggable: false
    };


    _.feedbackSettings = {
      template: '<div id="%%ID%%" class="mt-md-0 mt-2">%%MSG%%</div>',
      default: '<div id="%%ID%%" class="mt-md-0 mt-2">%%MSG%%</div>',
      icons: {
        loading: '<i class="fa-3x fa-circle-notch fa-spin fas"></i>',
        success: '<i class="fa-3x fas fa-check"></i>',
        info: '<i class="fa-3x fas fa-info"></i>',
        warning: '<i class="fa-3x fas fa-exclamation"></i>',
        error: '<i class="fa-3x fas fa-exclamation"></i>'
      }
    }


    if(arguments.length > 4){
      let options = arguments[4];
      _.mandatoryMarker = options.hasOwnProperty('mandatoryMarker') && options.mandatoryMarker ? options.mandatoryMarker : defaultMandatoryMarker;
      _.initCallback = options.hasOwnProperty('initCallback') && options.initCallback ? options.initCallback : function(){};
      _.mimeType = options.hasOwnProperty('mimeType') && options.mimeType ? options.mimeType : [];
      _.maxSize = options.hasOwnProperty('maxSize') && options.maxSize ? options.maxSize : 2097152;
      _.callbacks = options.hasOwnProperty('callbacks') && options.callbacks ? options.callbacks : null;
      _.successPopupId = options.hasOwnProperty('successPopupId') && options.successPopupId ? options.successPopupId : "contactConfirmed";
    }
    else{
      _.mandatoryMarker = defaultMandatoryMarker;
      _.initCallback = function(){};
      _.mimeType = [];
      _.maxSize = 2097152;
      _.callbacks = null;
      _.successPopupId = "contactConfirmed";
    }

    _.init();
  }
  else{
    console.error("No form found");
  }

  function fileValidation(file_data){
    let pass = false;
    if((file_data.length == 0) || (_.mimeType.length > 0 && !_.mimeType.inArray(file_data[0].type)) || (file_data[0].size > _.maxSize)){
      pass = false;
    }
    else{
      pass = true;
    }

    return pass;
  }
}

// prototype methods that will be shared
FormController.prototype = {
  init: function(){
    let _ = this;
    _.setFields();
    _.checkAllChecks();
    _.initCallback();
    _.senders.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        let formSelector = e.target.dataset.form;

        if(typeof(rekey) === "undefined"){
          _.send(e);
        }
        else{
          grecaptcha.ready(function(){
            let action = "formcontatti";
            // if(formSelector == "contactForm"){
            //   action = "formcontatti";
            // }
            // else if(formSelector == "contactForm"){
            //   action = "formfeedback";
            // }
            grecaptcha.execute(rekey, {action: action}).then(function(token){
                if(_.formNode.querySelector('#gre')){
                  _.formNode.querySelector('#gre').remove();
                }
                let input = document.createElement('INPUT');
                input.type = "hidden";
                input.id = "gre";
                input.name = "g-recaptcha-response";
                input.value = token;
                _.formNode.prepend(input);
                _.send(e);
            });
          });
        }
      })
    });

  },
  checkAllChecks: function(){
    let _ = this;
    document.querySelectorAll(_.formSelector + " .checkAllChecks[data-form='" + _.formSelector + "']").forEach((elem) => {
      elem.addEventListener('click', function(e){
        let scopeSelector = e.target.closest(".checkAllChecks").dataset.scope || ".privacyContentBlock";
        document.querySelectorAll(_.formSelector + " " + scopeSelector + " input[type='checkbox']").forEach((checkbox) => {
          if(!checkbox.checked){
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
          let errorLayer = checkbox.closest(".flatcustomCheckbox");
          if(errorLayer != null){
            errorLayer.classList.remove('error');
          }
        });
      });
    });
  },
  setFields: function(){
    let _ = this;
    Object.keys(_.elems).forEach((elemId, i) => {

      let descriptor = _.elems[elemId];
      let node = null;
      let textMandatoryField = "";    // label | placeholder
      let labelNode = null;
      let nodeName = null;            // INPUT | SELECT | TEXTAREA
      let nodeType = null;

      if(_.formNode.querySelector("#" + elemId)){
        node = _.formNode.querySelector("#" + elemId);
      }
      else{
        let elemName = elemId;
        if(_.formNode.querySelector("input[type='radio'][name='" + elemName + "']")){
          node = _.formNode.querySelector("input[type='radio'][name='" + elemName + "']");
        }
        else if(_.formNode.querySelector("input[type='checkbox'][name='" + elemName + "']")){
          node = _.formNode.querySelector("input[type='checkbox'][name='" + elemName + "']");
        }
      }

      if(node){  // if exists
        if(_.formNode.querySelector("[for='" + elemId + "']")){
          textMandatoryField = "label";
          label = _.formNode.querySelector("[for='" + elemId + "']");
        }
        else if(_.formNode.querySelector("[data-for='" + elemId + "']")){
          label = _.formNode.querySelector("[data-for='" + elemId + "']");
          textMandatoryField = "label";
        }
        else if(node.placeholder != ""){
          textMandatoryField = "placeholder";
        }

        nodeName = node.nodeName.toUpperCase();
        if(nodeName === "INPUT"){
          nodeType = node.getAttribute('type').toLowerCase();
        }

        // setting required attribute
        if(descriptor.required){

          if(nodeType !== "checkbox" || !(node.dataset.hasOwnProperty('relGroup') && node.dataset.hasOwnProperty('relGroup'))){
            node.setAttribute("required", "required");
          }
        }
        else{
          // reset required field and remove mandatoryMarker
          node.removeAttribute('required');
        }

        // setting mandatory marker
        if(textMandatoryField === 'label'){
          label.innerHTML = label.innerHTML.replace(_.mandatoryMarker, '');
          if(descriptor.required){
            label.innerHTML += _.mandatoryMarker;
          }
        }
        else if(textMandatoryField === 'placeholder'){
          node.placeholder.replace(_.mandatoryMarker, '')
          if(descriptor.required){
            node.placeholder += '*';
          }
        }

        // initialize default value
        if(descriptor.hasOwnProperty('default') && descriptor.default != null){
          if(nodeName === "INPUT" || nodeName === "SELECT"){
            if(nodeName === "SELECT"){
              node.value = descriptor.default;
              const event = new Event('change');
              node.dispatchEvent(event);
            }
            else{
              if(nodeType !== "checkbox" && nodeType !== "radio"){
                node.value = descriptor.default;
              }
              else{
                if(descriptor.default == "checked"){
                  node.setAttribute("checked", "checked");
                }
                else{
                  node.removeAttribute("checked");
                }
              }
            }
          }
          else if(nodeName === "TEXTAREA"){
            node.textContent = descriptor.default;
          }
        }

        //callback
        if(descriptor.hasOwnProperty('callback') && (typeof descriptor.callback).toLowerCase() === "function"){
          let params = [];
          if(descriptor.hasOwnProperty('callbackParams')){
            params = descriptor.callbackParams;
          }
          descriptor.callback.apply(node, params);
        }
      }

    });
  },
  getFormData: function(){
    let _ = this;
    let data = new FormData();
    _.formNode.querySelectorAll("input, select, textarea").forEach(elem => {
		
		
	
      let name = elem.getAttribute('name');
      let type = elem.getAttribute('type');

      if(type == "radio" || type == "checkbox"){
        if(elem.checked){
          data.append(name, elem.value);
        }
      }
      else if(type == "file"){
        data.append(name, elem.files[0]);
      }
      else{
        data.append(name, elem.value);
      }
    });

    return data;
  },
  clearModule: function(){
    let _ = this;
    _.formNode.reset();
    _.formNode.querySelectorAll("select.select2").forEach((elem) => {
      elem.dispatchEvent(new Event('change'));
    })
  },
  validate: function(){
    let _ = this;

    let result = {status: '', failedfields: [], passedfields: []};
    let pass = true;
    let elemPass = true;
    let errorBlockSelector = "";

    _.formNode.querySelectorAll("input[required], textarea[required], select[required]").forEach(elem => {

      let indexForFiled = elem.getAttribute("id");
      let nodeName = elem.nodeName.toUpperCase();
      let nodeType = elem.getAttribute("type");

      if(nodeName === "SELECT"){
        if(elem.value == "" || elem.value == -1 ){
          pass &= false;
          elemPass = false;
        }
        else{
          pass &= true;
          elemPass = true;
        }
      }
      else{
        if(nodeType == "checkbox"){

          if(elem.dataset.hasOwnProperty("relGroup") && elem.dataset.relGroup){
            let group = elem.dataset.relGroup;
            let min = 1;
            if(elem.dataset.hasOwnProperty("atLeast") && elem.dataset.atLeast){
              min = elem.dataset.atLeast;
            }

            if(_.formNode.querySelector("[data-rel-group='" + group + "']:checked")){
              pass &= true;
              elemPass = true;
            }
            else{
              pass &= false;
              elemPass = false;
            }
          }
          else{
            if(!elem.checked){
              pass &= false;
              elemPass = false;
            }
            else{
              pass &= true;
              elemPass = true;
            }
          }

        }
        else if(nodeType == "radio"){
          indexForFiled = elem.getAttribute("name");
          if(_.formNode.querySelector("input[name=" + indexForFiled + "]:checked")){
            pass &= true;
            elemPass = true;
          }
          else{
            pass &= false;
            elemPass = false;
          }
        }
        else if(nodeType == "file"){
          let file_data = elem.files;
          let filePass = fileValidation(file_data);
          pass &= filePass;
          elemPass = filePass;
        }
        else if(nodeName === "TEXTAREA"){
          if(elem.value == ""){
            pass &= false;
            elemPass = false;
          }
          else{
            pass &= true;
            elemPass = true;
          }
        }
        else{
          if(elem.value == ""){
            pass &= false;
            elemPass = false;
          }
          else{
            pass &= true;
            elemPass = true;
          }
        }
      }

      if(elemPass){
        if(indexForFiled && !result.passedfields.inArray(indexForFiled)){
          result.passedfields.push(indexForFiled);
        }
      }
      else{
        if(indexForFiled && !result.failedfields.inArray(indexForFiled)){
          result.failedfields.push(indexForFiled);
        }
      }

    });

    if(pass){
      result.status = 'passed';
    }
    else{
      result.status = 'failed';
    }

    return result;
  },
  send: function(){
    let _ = this;
    let validation = _.validate();

    if(validation.status == "passed"){

      let data = _.getFormData();
      data.append("sendmail", "sent");
      data.append("command", _.formNode.querySelector("[name='command']").value);
      cache = false;
      contentType = false;
      processData = false;

      let waiting = null;
console.log("endpoint");

console.log(_.endPoint);
      $.ajax({
        url: _.endPoint,
        cache: cache,
        contentType: contentType,
        processData: processData,
        data: data,
        dataType: 'json',
        method: 'post',
        beforeSend: function(){
          
          // let objectsClass = ["form-contacts", "form-contacts", "form-contacts", "form-contacts"];
          // if(data.get("command") != null){
          //   if(data.get("command") == "contatti_handler"){
          //     // _.popUpBaseOption.columnClass += " " + objectsClass[parseInt(data.get("oggetto")) - 1];  
          //     _.popUpBaseOption.columnClass += " form-contacts";  
          //   }
          //   if(data.get("command") == "newsletter_handler"){
          //     _.popUpBaseOption.columnClass += " form-newsletter";  
          //   }
          // }
          
          let feedInfoOption = JSON.parse(JSON.stringify(_.popUpBaseOption));
          feedInfoOption.title = titolo_attendere;
          feedInfoOption.content = _.getFeedback({type: 'loading', 'msg': '<p>' + msg_attendere_richiesta + '</p>'});

          waiting = $.dialog(feedInfoOption);
        },
        success: function(response){

          /*
          _iub.cons_instructions.push(["submit", {
              writeOnLocalStorage: false, // default: false
              form: { selector: _.formNode, },
              consent: {
                  legal_notices: [
                      { identifier: 'privacy_policy', },
                      { identifier: 'cookie_policy', },
                  ],
              }
          },{
              success: function(response) { console.log(response); }, 
              error: function(response) { console.log(_.formSelector + response); }
          }])
          */

          

          if(typeof(waiting) != "undefined" && waiting != null){
            waiting.close();
          }

          let feedOpt = JSON.parse(JSON.stringify(_.popUpBaseOption));

          if(response.status == "success"){
            feedOpt.type = "green";
            feedOpt.title = titolo_successo;
            feedOpt.content = _.getFeedback({'msg': response.msg, id: _.successPopupId});
            _.clearModule();

            if(_.callbacks && _.callbacks.hasOwnProperty("success") && typeof(_.callbacks.success) === "function"){
              _.callbacks.success();
            }
          }
          else if(response.status == "warning"){
            feedOpt.type = "yellow";
            feedOpt.title = titolo_attenzione;
            feedOpt.content = _.getFeedback({type: 'warning', 'msg': response.msg});
          }
          else if(response.status == "error"){
            feedOpt.type = "red";
            feedOpt.title = titolo_errore;
            feedOpt.content = _.getFeedback({type: 'error', 'msg': response.msg});

            if(_.callbacks && _.callbacks.hasOwnProperty("error") && typeof(_.callbacks.error) === "function"){
              _.callbacks.error();
            }
          }
          else if(response.status == "info" || response.status == "notice"){
            feedOpt.title = titolo_info;
            feedOpt.content = _.getFeedback({type: 'info', 'msg': response.msg});
            _.clearModule();
          }

          $.dialog(feedOpt);
        },
        error: function(error){
          let msg = "";
          if(error.statusText ==="timeout"){
            msg = denied_mail_service;
          }
          else{
            if(error.hasOwnProperty('responseJSON') && error.responseJSON){
              error = error.responseJSON;
            }
            else{
              error = JSON.parse(error.responseText);
            }
            msg = error.msg;
            if(error.hasOwnProperty('data') && error.data){
              _.setError(error.data);
            }
          }
          waiting.close();

          let feedErrorOption = JSON.parse(JSON.stringify(_.popUpBaseOption));
          feedErrorOption.title = titolo_errore;
          feedErrorOption.type = "red";
          feedErrorOption.content = _.getFeedback({type: 'error', 'msg': msg});

          _.errorClickRemoverBinder();

          if(_.callbacks && _.callbacks.hasOwnProperty("error") && typeof(_.callbacks.error) === "function"){
            _.callbacks.error();
          }

          $.dialog(feedErrorOption);
        }
      });
    }
    else{

      let feedErrorOption = JSON.parse(JSON.stringify(_.popUpBaseOption));
      feedErrorOption.title = titolo_errore;
      feedErrorOption.type = "red";
      feedErrorOption.content = _.getFeedback({type: 'error', 'msg': '<p>' + msg_errore_generico + '</p>' + _.getError(validation.failedfields)});
      feedErrorOption.buttons = {
        close: {
          text: act_error,
        }
      }

      if(validation.hasOwnProperty('failedfields') && validation.failedfields){
        _.setError(validation.failedfields);
      }
      _.errorClickRemoverBinder();

      $.confirm(feedErrorOption);
    }
  },
  getFeedback: function(feedSetting){
    let _ = this;

    let _default = {
      type: 'success',
      template: _.feedbackSettings.template,
      icons: JSON.parse(JSON.stringify(_.feedbackSettings.icons)),
      id: 'contactConfirmed',
      msg: '',  // unico campo obbligatorio
    }

    Object.keys(_default).forEach(key => {
      if(!feedSetting.hasOwnProperty(key) || !feedSetting[key]){
        feedSetting[key] = _default[key];
      }
    });

    if(feedSetting.type != "success"){
      feedSetting.id = "";
    }

    return feedSetting.template
            .replaceAll('%%ICON%%', feedSetting.icons[feedSetting.type])
            .replaceAll('%%MSG%%', feedSetting.msg)
            .replaceAll('%%ID%%', feedSetting.id);
  },
  setError: function(failedFields){
    let _ = this;

    _.formNode.querySelectorAll(".flat.error, .flatcustomCheckbox.error").forEach(elem => {
      elem.classList.remove("error");
    });

    failedFields.forEach(failedField => {
	
      let elem = _.formNode.querySelector("#" + failedField);
	  if ((elem !== undefined) &&(elem !== null) ){
      let parent = elem.closest(".flat");
      if(parent){
        parent.classList.add("error");
      }
      else{
        if(elem.getAttribute('type') == "radio"){
          filedName = elem.getAttribute("name");
          if(_.formNode.querySelector("input[type=radio][name=" + filedName + "]").closest(".radioChooser")){
            _.formNode.querySelector("input[type=radio][name=" + filedName + "]").closest(".radioChooser").classList.add("error");
          }
        }
        else{
          if(elem.closest(".flatcustomCheckbox")){
            elem.closest(".flatcustomCheckbox").classList.add("error");
          }
        }
      }
	  }
    });
  },
  getError: function(fields){
    let _ = this;
    let field = '', msg = [];

    for(let i = 0; i < fields.length; i++){
      field = fields[i];
      if(field == 'privacy' || field == 'newsletterPrivacy' || field == 'nlPrivacy' || field == 'lbPrivacy'){
        msg.push('<li>Privacy</li>');
      }
      else{
        let label = "";
        if(_.formNode.querySelector("[data-for='" + field + "']")){
          label = _.formNode.querySelector("[data-for='" + field + "']").textContent;
        }
        else if(_.formNode.querySelector("label[for='" + field + "']")){
          label = _.formNode.querySelector("label[for='" + field + "']").textContent;
        }
        else if(_.formNode.querySelector("#" + field).placeholder != ""){
          label = _.formNode.querySelector("#" + field).placeholder;
        }

        if(label != ""){
          msg.push('<li>' + label.replace(_.mandatoryMarker, '') + '</li>');
        }
      }
    }

    if(msg.length > 0){
      return '<ul>' + msg.join('') + '</ul>';
    }
    else{
      return '';
    }
  },
  errorClickRemoverBinder: function(){
    let _ = this;

    let removeError = function(e){
      let elem = e.target;
      if(elem.classList.contains("radioChooser")){
        let name = elem.querySelector("input").getAttribute("name");
        _.formNode.querySelector("input[name=" + name + "]").closest(".error").classList.remove("error");
      }
      else{
        elem.classList.remove("error");
      }
    }

    _.formNode.querySelectorAll(".flat.error, .flatcustomCheckbox.error, .radioChooser.error").forEach(elem => {
      elem.addEventListener('click', removeError);
      elem.removeEventListener('click', removeError);
    });

  }
};